import { useAccountCompanyId } from 'application/hooks';

import { useCreateVideoStreamMutation, useUpdateVideoStreamMutation } from 'domain/api/graphql/generated';

export const useCreateVideoStreamPresenter = () => {
  const [createVideoStreamMutation] = useCreateVideoStreamMutation();
  const [updateVideoStreamMutation] = useUpdateVideoStreamMutation();

  const companyId = useAccountCompanyId();

  return {
    createVideoStream: createVideoStreamMutation,
    updateVideoStream: updateVideoStreamMutation,
    companyId,
  };
};
